/** Turn axios / FastAPI errors into a short user-facing message. */
export function apiErrorMessage(err, fallback = "Request failed") {
  const detail = err?.response?.data?.detail;
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail) && detail[0]?.msg) return detail.map((d) => d.msg).join("; ");
  const status = err?.response?.status;
  if (status === 401) return "Session expired — please log in again.";
  if (status === 404) return "API not found — restart the backend (see README).";
  if (err?.message === "Network Error") {
    return "Cannot reach the backend. Is it running on port 8000?";
  }
  return fallback;
}
